document.addEventListener("DOMContentLoaded", function () {
  // Select the parent div, which is the actual visual container
  const orbitvuPopupContainer = document.querySelector('.productView-orbitvuPopup');
  // Keep the reference to the internal link/button if you need to manipulate its attributes
  const orbitvuButton = document.querySelector('.orbitvu-button'); // This is the <a> tag inside

  const orbitvuDataEl = document.getElementById('OrbitvuVariantData');

  // Crucially, check if the container exists
  if (!orbitvuPopupContainer || !orbitvuButton || !orbitvuDataEl) return;

  let orbitvuMap = {};
  try {
    orbitvuMap = JSON.parse(orbitvuDataEl.textContent);
  } catch (e) {
    console.error("Invalid Orbitvu JSON", e);
  }

  const fallbackOrbitvu = orbitvuMap.product || null;

  function checkImageExists(shareCode, callback) {
    const img = new Image();
    img.onload = () => callback(true);
    img.onerror = () => callback(false);
    img.src = `https://cdn.orbitvu.co/share/${shareCode}/still/view?width=200&height=200`;
  }

  function updateOrbitvuButton(variantId) {
    const variantCode = orbitvuMap[variantId];
    const newCode = variantCode || fallbackOrbitvu;

    // Hide the *container* immediately while we validate
    orbitvuPopupContainer.style.display = 'none';

    if (!newCode || typeof newCode !== "string") {
      console.warn("⛔️ Invalid Orbitvu code:", newCode);
      orbitvuButton.removeAttribute('href'); // Still good to clear these
      orbitvuButton.removeAttribute('data-orbitvu-code');
      return;
    }

    const shareCode = newCode.includes('/') ? newCode.split('/')[0] : newCode;

    console.log("🔍 Validating Orbitvu code:", newCode);
    console.log("📷 Testing thumbnail:", `https://cdn.orbitvu.co/share/${shareCode}/still/view?width=200&height=200`);

    checkImageExists(shareCode, (exists) => {
      if (exists) {
        const viewerUrl = `https://orbitvu.co/share/${newCode}/360/iframe?width=auto&height=auto&content2=yes&partial_load=yes`;
        orbitvuButton.setAttribute('href', viewerUrl);
        orbitvuButton.setAttribute('data-orbitvu-code', newCode);
        // Show the *container* if everything is valid
        orbitvuPopupContainer.style.display = 'block';
        console.log("✅ Orbitvu confirmed, showing button");
      } else {
        // Ensure the container remains hidden
        orbitvuPopupContainer.style.display = 'none';
        orbitvuButton.removeAttribute('href');
        orbitvuButton.removeAttribute('data-orbitvu-code');
        console.warn("❌ Orbitvu thumbnail not found. Hiding button.");
      }
    });
  }

  // Initial variant
  const initialVariantId = Shopify?.product?.selected_or_first_available_variant?.id?.toString();
  if (initialVariantId) updateOrbitvuButton(initialVariantId);

  // Manual listener for <variant-radios> change
  const variantRadios = document.querySelector('variant-radios');
  if (variantRadios) {
    variantRadios.addEventListener('change', () => {
      const selectedInput = variantRadios.querySelector('input[type="radio"]:checked');
      const variantId = selectedInput?.dataset?.variantId;
      if (variantId) updateOrbitvuButton(variantId);
    });
  }
});